export default __webpack_public_path__ + "locales/ru/Webhooks.json?hash=4755bfa791cc3c4d9c5e7411f1059de7";